<button 
    #filterToggle 
    type="button" 
    (click)="btnFilterService.openFilter(filterId)" 
    class="btn btn-sm btn-outline-secondary hide-on-print filter-btn"
>
    <fa-icon [icon]="faIconName.faFilter"></fa-icon>
	Apply Filters
</button>